<ion-row class="ion-margin" *ngIf="!noLabel">
  <ion-label [color]="(cFormControl.dirty && cFormControl.invalid && !((field.readonly ?? 0) | readonlyByRule: etatId)) ? 'danger' : undefined" style="width: 100%;">
    <div [innerHtml]="field.label | fetchImageFromHtmlPipe:field['images'] | async | trustHtmlPipe"></div>
  </ion-label>
</ion-row>

<ng-container *ngIf="field?.multiple !== 1; else Multiple">
  <ion-radio-group [formControl]="cFormControl">
    <ion-item *ngFor="let option of field.options" [disabled]="disabledField" [ngClass]="{'gl-disable-invisible': disabledField && !looksDisabled, 'item-disabled': (field.readonly ?? 0) | readonlyByRule: etatId}">
      <ion-radio class="gl-style-radio gl-style-radio-html-label" [disabled]="cFormControl.disabled || ((field.readonly ?? 0) | readonlyByRule: etatId)" [color]="option.color" [value]="option.value" mode="md">
        <div [innerHtml]="option.label | fetchImageFromHtmlPipe:option['images'] | async | trustHtmlPipe">
        </div>
        &nbsp;
      </ion-radio>
    </ion-item>
  </ion-radio-group>
</ng-container>

<ng-template #Multiple>
  <ion-item *ngFor="let option of field.options" [disabled]="disabledField" [ngClass]="{'gl-disable-invisible': disabledField && !looksDisabled, 'item-disabled': (field.readonly ?? 0) | readonlyByRule: etatId}">
    <ion-checkbox class="gl-style-checkbox gl-style-radio-html-label" [disabled]="cFormControl.disabled || ((field.readonly ?? 0) | readonlyByRule: etatId)" [color]="option.color" [value]="option.value" [checked]="option.value | isContainedInControlValuePipe:cFormControl.value" mode="md" (ionChange)="editCFormValue($event, option.value)">
      <div [innerHtml]="option.label | fetchImageFromHtmlPipe:option['images'] | async | trustHtmlPipe">
      </div>
      &nbsp;
    </ion-checkbox>
  </ion-item>
</ng-template>